module.exports = __webpack_public_path__ + "img/bookcase-md-bottom.eca366e3.svg";